import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_2 = ({ eyeColours, skinColours }) => {
  const colour0 = '#F15743';
  const colour1 = '#FFFEF0';
  const colour2 = '#F6E7D0';
  const colour3 = eyeColours.shadow;
  const colour4 = '#DF5656';
  const colour5 = skinColours.shadow;
  const colour6 = '#B7E3E9';

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M423.9,388c-2.6-0.8-7.1-4.2-6.8-5.3c3.3-13.4,13.1-23,13.1-23L423.9,388z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M471.8,391.9c2.8-0.8,7.3-4.2,7.1-5.3c-0.8-5.6-10.1-20.7-10.1-20.7L471.8,391.9z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M474,386.6c0-18.8-12.5-35.1-26.6-35.1c-14.1,0-25.5,15.2-25.5,34c0,18.8,11.4,34,25.5,34
			C461.5,419.4,474,405.4,474,386.6z"
          />
          <path
            fill={colour1}
            d="M470.8,385.5c0-18.1-10.4-32.8-23.3-32.8c-12.9,0-23.3,14.7-23.3,32.8s10.4,29.7,23.3,29.7
			C460.3,415.1,470.8,403.6,470.8,385.5z"
          />
          <path
            fill={colour2}
            d="M448.7,410.9c-12.9,0-23.3-12.4-23.3-30.5c0-2.9,0.3-5.7,0.8-8.4c-1.3,4.1-2.1,8.7-2.1,13.5
			c0,18.1,10.4,30.5,23.3,30.5c10.9,0,20.1-9,22.6-22.8C466.4,404.1,458.3,410.9,448.7,410.9z"
          />
          <path
            fill={colour3}
            d="M460.9,386.4c0-10.2-6.2-18.5-13.8-18.5c-7.6,0-13.8,8.3-13.8,18.5c0,10.2,6.2,18.5,13.8,18.5
			C454.7,404.8,460.9,396.5,460.9,386.4z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M479,386.5c-6-16.4-15.3-32.2-29.7-32.2c-12.9,0-29.3,12.9-31.6,28.2C432.1,352.6,461,345.8,479,386.5z"
          />
          <path
            fill={colour5}
            d="M418.4,379.4c6.3-23.1,39.2-45.9,59.2,3.8c0,0-4.8-33.2-28.9-33.2C420.8,350,418.4,379.4,418.4,379.4z"
          />
          <path
            fill={colour5}
            d="M418.1,375.9c-0.7,4-0.9,6.6-0.9,6.6c5.8-22.1,40-47,61.8,4c0,0-0.2-2.1-0.8-5.5
			C459.2,335,430,351.9,418.1,375.9z"
          />
          <path
            fill={colour1}
            d="M461.4,392c0-2.6-1.4-4.8-3.1-4.8c-1.7,0-3.1,2.1-3.1,4.8c0,2.6,1.4,4.8,3.1,4.8
			C460,396.8,461.4,394.7,461.4,392z"
          />
          <path
            fill={colour1}
            d="M456.4,380c-0.6-1.4-1.5-2.2-2.2-1.8c-0.6,0.4-0.7,1.8-0.2,3.2c0.6,1.4,1.5,2.2,2.2,1.8
			C456.9,382.8,457,381.3,456.4,380z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M374,387.3c2.7-0.8,7.2-4.2,7-5.3c-3.4-13.4-13.4-23-13.4-23L374,387.3z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M324.9,391.3c-2.8-0.8-7.5-4.2-7.3-5.3c0.8-5.6,10.4-20.7,10.4-20.7L324.9,391.3z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M322.7,385.9c0-18.8,12.8-35.1,27.2-35.1c14.4,0,26.1,15.2,26.1,34c0,18.8-11.7,34-26.1,34
			C335.5,418.7,322.7,404.7,322.7,385.9z"
          />
          <path
            fill={colour1}
            d="M326.1,384.8c0-18.1,10.7-32.8,23.9-32.8c13.2,0,23.9,14.7,23.9,32.8c0,18.1-10.7,29.7-23.9,29.7
			C336.7,414.4,326.1,402.9,326.1,384.8z"
          />
          <path
            fill={colour2}
            d="M348.6,410.2c13.2,0,23.9-12.4,23.9-30.5c0-2.9-0.3-5.7-0.8-8.4c1.4,4.1,2.1,8.7,2.1,13.5
			c0,18.1-10.7,30.5-23.9,30.5c-11.2,0-20.6-9-23.2-22.8C330.5,403.4,338.8,410.2,348.6,410.2z"
          />
          <path
            fill={colour3}
            d="M336.1,385.7c0-10.2,6.3-18.5,14.1-18.5c7.8,0,14.1,8.3,14.1,18.5s-6.3,18.5-14.1,18.5
			C342.5,404.1,336.1,395.9,336.1,385.7z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M317.7,385.8c6.2-16.4,15.7-32.2,30.4-32.2c13.2,0,30,12.9,32.3,28.2C366.1,352,336.5,345.1,317.7,385.8z"
          />
          <path
            fill={colour5}
            d="M379.6,378.7c-6.5-23.1-40.1-45.9-60.6,3.8c0,0,4.9-33.2,29.6-33.2C377.2,349.3,379.6,378.7,379.6,378.7z"
          />
          <path
            fill={colour5}
            d="M380,375.2c0.7,4,0.9,6.6,0.9,6.6c-6-22.1-41-47-63.2,4c0,0,0.2-2.1,0.8-5.5
			C337.9,334.3,367.8,351.2,380,375.2z"
          />
          <path
            fill={colour1}
            d="M335.6,391.3c0-2.6,1.4-4.8,3.1-4.8s3.1,2.1,3.1,4.8c0,2.6-1.4,4.8-3.1,4.8S335.6,394,335.6,391.3z"
          />
          <path
            fill={colour1}
            d="M340.7,379.3c0.6-1.4,1.6-2.2,2.2-1.8c0.7,0.4,0.7,1.8,0.2,3.2c-0.6,1.4-1.6,2.2-2.2,1.8
			C340.2,382.1,340.1,380.7,340.7,379.3z"
          />
        </g>
        <path
          fill={colour6}
          d="M482.4,404c4.5,1.3,8.4,5.5,6.5,6.5C487,411.4,482.4,404,482.4,404z"
        />
        <path
          fill={colour6}
          d="M323.1,425.6c-0.2,4.7-3.3,9.5-4.7,7.8C316.9,431.7,323.1,425.6,323.1,425.6z"
        />
        <path
          fill={colour6}
          d="M316.8,402.4c-3.9,2.6-9.6,2.9-9.1,0.8C308.1,401.1,316.8,402.4,316.8,402.4z"
        />
      </g>
    </>
  );
};

export default Eyes_2;
